import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 4: Nobles and Aristocrats — Yangban</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 4: 고려와 조선의 양반</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">
                
<span class="italics">Listen to the episode <a target="_blank" href="https://anchor.fm/learn-korean-culture/episodes/S2--Episode-4-Nobles-and-Aristocrats-e15ao5e">here</a>!</span> <br></br>
<br></br>

{/*INTRO*/}
신라 (sin la) — silla, one of the kingdoms during the 삼국시대 (Three kingdoms period)  <br></br>
한반도 (han ban do) — Korean peninsula  <br></br>
통일하다 (tong il ha da) — to unify  <br></br>
통일신라 (ton il sin la) — unified Silla, consists of the unified kingdoms in the Korean peninsula  <br></br>
왕건 (wang gun) — founder of 고려, a kingdom that takes over the unified 신라 and the rest of the Korean peninsula  <br></br>

<br></br>
{/*YANGBAN*/}
양반 (yang ban) — nobles/aristocrats that were of the highest social status  <br></br>
최상급 (che sang geup) — the highest  <br></br>
사회계급 (sah hwe gae geup) — social classes  <br></br>
사회 (sah hwae) — society  <br></br>
계급 (gae geup) — class  <br></br>
정치 (jung chi) — politics  <br></br>
참여하다 (cham yeo ha da) — to participate  <br></br>
관료인 (gwan ryo in) — bureaucrats  <br></br>
성리학 (sung ri hak) — Neo-confucianism  <br></br>
학자 (hak jah) — scholar  <br></br>
역할 (yeok hal) — role  <br></br>

<br></br>
{/*POWER AND RICH*/}
세력 (sae ryeok) — influence  <br></br>
권력 (gwon ryeok) — power  <br></br>
만만하지 않다 (mahn mahn ha ji andt da) — not to be underestimated  <br></br>
풍요롭다 (pung yo ryop da) — affluent  <br></br>
생활 (saeng hwal) — lifestyle   <br></br>
토지 (toji) — land  <br></br>
노비 (noh bi) — slaves  <br></br>
부유하다 (bu yu ha da) — to be wealthy  <br></br>

<br></br>
{/*THE EXAM*/}
과거 (gwa guh) — a test one had to pass in order to become a 양반 (yangban). This test was government sponsored and tested writing abilities, knowledge of Confucian classics and managing the state, and more  <br></br>
합격하다 (hap gyuk ha da) — to pass (the test)  <br></br>
아주 (ah juh) — very  <br></br>
어렵다 (uh ryeop da) — to be difficult  <br></br>
천민 (chun min) — the lowest social class  <br></br>
제외하고 (jae wae ha go) — excluding  <br></br>
하지만 (ha ji man) — but  <br></br>
현실적 (hyeon sil juk) — realistically  <br></br>
말하다 (mal ha da) — talk  <br></br>
가문 (gah mun) — family  <br></br>
사람들 (sah ram deul) — people  <br></br>
시험 (si hum) — test  <br></br>
시험을 보다 (si hum eul bo da) — to take the test  <br></br>
합격하다 (hap gyeok ha da) — to pass  <br></br>
불가능 (bul ga neung) — impossible  <br></br>
경제적 (gyeong jae juk) — monetarily or economically  <br></br>
여유 (yuh yoo) — margin or relaxation  <br></br>

<br></br>
{/*CLOTHING*/}
옷차림 (ot cha rim) — clothes <br></br>
<br></br> Pictured below: the typical clothes of a 양반 (yangban)<br></br>
<img className="epPic-m" src="http://www.kjclub.com/data/exc_board_9/2017/05/14/1494750676_98285ec0a6dca0179709eff90cab2954.jpg"></img><br></br>
<br></br>
신분 (sin boon) — status  <br></br>
직책 (jik chaek) — job/position  <br></br>
학 (hak) — crane  <br></br>
호랑이 (ho rang eeh) — tiger  <br></br>
동물 (dong mul) — animals  <br></br>
수놓다 (soo not da) — to embroider  <br></br>
평상시에 (pyeong sang si ae) — normally  <br></br>
갓 (gat) — a type of hat, kind of looks like a wider top hat (pictured below)  <br></br>
<br></br>
<img className="epPic-m" src="https://dimg.donga.com/wps/NEWS/IMAGE/2019/09/17/97435412.2.jpg"></img><br></br>
<br></br>


                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;